export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["active"] = "active";
    SubscriptionStatus["canceled"] = "canceled";
    SubscriptionStatus["incomplete"] = "incomplete";
    SubscriptionStatus["incomplete_expired"] = "incomplete_expired";
    SubscriptionStatus["past_due"] = "past_due";
    SubscriptionStatus["paused"] = "paused";
    SubscriptionStatus["trialing"] = "trialing";
    SubscriptionStatus["unpaid"] = "unpaid";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export const unrecoverableSubscriptionStatuses = [
    SubscriptionStatus.canceled,
    SubscriptionStatus.incomplete_expired,
    SubscriptionStatus.unpaid,
];
//# sourceMappingURL=subscription-status.enum.js.map